"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteManagedImageUtil = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _RemoteManagedImageUtilJs = require("./RemoteManagedImageUtilJs");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RemoteManagedImageUtil = /*#__PURE__*/function (_RemoteManagedImageUt) {
  (0, _inherits2.default)(RemoteManagedImageUtil, _RemoteManagedImageUt);

  var _super = _createSuper(RemoteManagedImageUtil);

  function RemoteManagedImageUtil(auth, firestore) {
    var _this;

    (0, _classCallCheck2.default)(this, RemoteManagedImageUtil);
    _this = _super.call(this, auth, firestore);
    return (0, _possibleConstructorReturn2.default)(_this, (0, _assertThisInitialized2.default)(_this));
  }

  (0, _createClass2.default)(RemoteManagedImageUtil, [{
    key: "getManagedImageList",
    value: function getManagedImageList() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteManagedImageUtil.prototype), "getManagedImageList", this).call(this);
    }
  }, {
    key: "getManagedImage",
    value: function getManagedImage(id) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteManagedImageUtil.prototype), "getManagedImage", this).call(this, id);
    }
  }, {
    key: "setManagedImageMetadata",
    value: function setManagedImageMetadata(image) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteManagedImageUtil.prototype), "setManagedImageMetadata", this).call(this, image);
    }
  }, {
    key: "setManagedImageSettings",
    value: function setManagedImageSettings(settings) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteManagedImageUtil.prototype), "setManagedImageSettings", this).call(this, settings);
    }
  }, {
    key: "getManagedImageSettings",
    value: function getManagedImageSettings() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(RemoteManagedImageUtil.prototype), "getManagedImageSettings", this).call(this);
    }
  }]);
  return RemoteManagedImageUtil;
}(_RemoteManagedImageUtilJs.RemoteManagedImageUtilJs);

exports.RemoteManagedImageUtil = RemoteManagedImageUtil;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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